export class Modal{
    actions: boolean;
    name: string;
    title: string;
    description: string;
    actionButtonText: string;
    modalForm: {};
    style: {};
    version: string;
    type: string;
    config: {
        keepOpenAfterSubmit: boolean,
        allowInlineMessage: boolean
    } = {
        allowInlineMessage: false,
        keepOpenAfterSubmit: false
    };
    data: {};

    constructor(data){
        this.actions = data.action;
        this.name = data.name;
        this.title = data.title;
        this.description = data.description;
        this.actionButtonText = data.actionButtonText;
        this.modalForm = data.modalForm;
        this.style = data.style || null;
        this.version = data.version;
        this.type = data.type;
        this.config = data.config !== undefined ? { ...this.config, ...data.config } : this.config;
        this.data = data.data || null;
    }
}
